import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import InputSearch from './InputSearch';

const FindBar = ({
  onSearch,
  onGenderChange,
  onCategoriesChange,
  initialGender = 'All',
  hideCategories = true,
  hideGender = false,
  searchValue,
}) => {
  const [visible, setVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const handleScroll = useCallback(() => {
    const currentScrollPos = window.pageYOffset;
    setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
    setPrevScrollPos(currentScrollPos);
  }, [prevScrollPos]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleGenderFilter = useCallback((selectedGender) => {
    if (onGenderChange) {
      onGenderChange(selectedGender);
    }
  }, [onGenderChange]);

  return (
    <div 
      className={`sticky top-0 z-10 w-full bg-white dark:bg-gray-900 shadow-sm transition-transform duration-300 ${visible ? 'translate-y-0' : '-translate-y-full'}`}
    >
      <div className="pt-16">
        <div className="w-full flex flex-col items-center pt-6">
          <div className="w-full md:w-[50%] px-2 mb-1">
            <InputSearch
              handlerCategories={onCategoriesChange}
              handlerSearch={onSearch}
              send={onSearch}
              hideCategories={hideCategories}
              value={searchValue}
            />
          </div>
          {!hideGender && (
            <div className="w-full flex flex-wrap gap-1 justify-center px-2">
              {['All', 'female', 'male', 'trans'].map((genderOption) => (
                <button
                  key={genderOption}
                  onClick={() => handleGenderFilter(genderOption)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                    initialGender === genderOption 
                      ? 'bg-rose-500 text-white' 
                      : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600'
                  }`}
                >
                  {genderOption.charAt(0).toUpperCase() + genderOption.slice(1)}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

FindBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onGenderChange: PropTypes.func.isRequired,
  onCategoriesChange: PropTypes.func,
  initialGender: PropTypes.string,
  hideCategories: PropTypes.bool,
  hideGender: PropTypes.bool,
  searchValue: PropTypes.string,
};

export default React.memo(FindBar);
